
























































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { Routes } from "@/router/routes";
import logger from "@/configs/logger";
import DispositionGroups from "@/components/DispositionGroups.vue";
import { snakeCase } from "lodash";
import { collections, firestore } from "@/configs/firebase";
import FeatureConfigs from "@/helpers/featureConfigs";
import featureConfigs from "@/helpers/featureConfigs";

@Component({ components: { DispositionGroups } })
export default class Dispositions extends Vue {
  requiresNote = false;
  continueDialing = false;
  noConvoso = false;
  isDnc = false;
  isCallback = false;
  agedDialing = false;
  newDispositionDialog = false;
  newDisposition = "";

  newGroupDialog = false;
  newGroupName = "";
  newGroupDescription = "";

  dispositions: any[] = [];
  dispositionGroups: any[] = [];

  dispositionDetailsDialog = false;
  activeDisposition: any = null;

  snack = false;
  snackText = "";
  snackColor = "";

  loading = false;

  @Watch("dispositionDetailsDialog")
  onDialogChange(val: Boolean) {
    if (!val) {
      this.activeDisposition = null;
    }
  }

  mounted() {
    this.getDispositions();
    this.getDispositionGroups();
  }

  get newDispositionId() {
    return snakeCase(this.newDisposition);
  }

  get newGroupId() {
    return snakeCase(this.newGroupName);
  }

  get dispositionValues() {
    return this.dispositions.map((item: any) => item.name);
  }

  get groupTypes() {
    return featureConfigs.getGroupTypes();
  }

  showSnack(message: string, type: "success" | "info" | "error") {
    this.snack = true;
    this.snackColor = type || "info";
    this.snackText = message;
  }

  closeDispositionDetails() {
    this.activeDisposition = null;
    this.dispositionDetailsDialog = false;
  }

  viewDispositionDetails(disposition: any) {
    this.activeDisposition = { ...disposition };
    this.dispositionDetailsDialog = true;

    logger("log", "LOOK:", this.activeDisposition);
  }

  async deleteDisposition() {
    const confirmed = window.confirm(
      "Are sure you want to delete this disposition for all groups"
    );
    if (confirmed) {
      try {
        await Promise.all([
          collections.dispositions.doc(this.activeDisposition.id).delete(),
          ...this.dispositionGroups.map((group: any) =>
            collections.dispositionGroups.doc(group.id).update({
              dispositions: firestore.FieldValue.arrayRemove(
                this.activeDisposition.name
              )
            })
          )
        ]);
        this.getDispositions();
        this.getDispositionGroups();
      } catch (err) {
        logger("error", "delete disposition error:", err);
      }
    }
  }

  async createDisposition() {
    try {
      collections.dispositions.doc(this.newDispositionId).set({
        requiresNote: this.requiresNote,
        continueDialing: this.continueDialing,
        noConvoso: this.noConvoso,
        name: this.newDisposition,
        dnc: this.isDnc,
        callback: this.isCallback,
        agedDialing: this.agedDialing,
        id: this.newDispositionId
      });
      this.getDispositions();
      this.newDisposition = "";
      this.requiresNote = false;
      this.newDispositionDialog = false;
      this.continueDialing = false;
      this.noConvoso = false;
      this.isDnc = false;
      this.isCallback = false;
      this.agedDialing = false;
      this.showSnack("Disposition created!", "success");
    } catch (err) {
      logger("error", "create disposition error:", err);
    }
  }

  async updateDisposition() {
    this.loading = true;
    try {
      await collections.dispositions
        .doc(this.activeDisposition.id)
        .update(this.activeDisposition);
      this.getDispositions();
      this.showSnack("Disposition updated!", "success");
      this.loading = false;
    } catch (error) {
      logger("error", "update disposition error:", error);
      this.loading = false;
    }
  }

  async createGroup() {
    try {
      collections.dispositionGroups.doc(this.newGroupId).set({
        id: this.newGroupId,
        name: this.newGroupName,
        description: this.newGroupDescription,
        dispositions: []
      });
      this.getDispositionGroups();
      this.newGroupDescription = "";
      this.newGroupDialog = false;
      this.newGroupName = "";
      this.showSnack("Group created!", "success");
    } catch (err) {
      logger("error", "create disposition group error:", err);
    }
  }

  async getDispositions() {
    try {
      const snapshot = await collections.dispositions.get();
      this.dispositions = snapshot.docs.map((doc: any) => doc.data());
      console.log(this.dispositions);
    } catch (err) {
      logger("error", "get dispositions error:", err);
    }
  }

  async getDispositionGroups() {
    try {
      const snapshot = await collections.dispositionGroups.get();
      this.dispositionGroups = snapshot.docs.map(doc => doc.data());
    } catch (err) {
      logger("error", "get disposition groups error:", err);
    }
  }
}
